import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-548a20d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-center footer-container" }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = ["href", "onClick"]
const _hoisted_7 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_BriefcaseIcon = _resolveComponent("BriefcaseIcon")!
  const _component_MessageSquareIcon = _resolveComponent("MessageSquareIcon")!
  const _component_FavoriteAndWatchLaterIcon = _resolveComponent("FavoriteAndWatchLaterIcon")!
  const _component_UserIcon = _resolveComponent("UserIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        custom: "",
        to: { name: 'Search' }
      }, {
        default: _withCtx(({ href, navigate }) => [
          _createElementVNode("span", {
            class: "section text-center",
            href: href,
            onClick: navigate
          }, [
            _createVNode(_component_SearchIcon, {
              checked: _ctx.isActiveSearchLink,
              "wrapper-class": _ctx.textColor(_ctx.isActiveSearchLink)
            }, null, 8, ["checked", "wrapper-class"]),
            _createTextVNode(),
            _createElementVNode("p", {
              class: _normalizeClass(["icon-text", _ctx.textColor(_ctx.isActiveSearchLink)])
            }, "\n            探す\n          ", 2)
          ], 8, _hoisted_3)
        ]),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        custom: "",
        to: { name: 'ApplicationsList', query: _ctx.$route.query }
      }, {
        default: _withCtx(({ href, navigate, isActive }) => [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "section text-center",
                href: href,
                onClick: navigate
              }, [
                (_ctx.notificationApplicationCount !== 0)
                  ? (_openBlock(), _createBlock(_component_AppBadge, {
                      key: 0,
                      variant: "red",
                      class: "rejected-num"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.notificationApplicationCount), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_BriefcaseIcon, {
                  checked: isActive,
                  "wrapper-class": _ctx.textColor(isActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isActive)])
                }, "\n              仕事管理\n            ", 2)
              ], 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "section text-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmLogin && _ctx.confirmLogin(...args)))
              }, [
                _createVNode(_component_BriefcaseIcon, {
                  checked: isActive,
                  "wrapper-class": _ctx.textColor(isActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isActive)])
                }, "\n              仕事管理\n            ", 2)
              ]))
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        custom: "",
        to: { name: 'MessageRooms' }
      }, {
        default: _withCtx(({ href, navigate, isExactActive }) => [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "section text-center",
                href: href,
                onClick: navigate
              }, [
                (_ctx.unreadMessageAndInformationCount !== 0)
                  ? (_openBlock(), _createBlock(_component_AppBadge, {
                      key: 0,
                      variant: "red",
                      class: "notification"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.unreadMessageAndInformationCount), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_MessageSquareIcon, {
                  checked: isExactActive,
                  "wrapper-class": _ctx.textColor(isExactActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isExactActive)])
                }, "\n              メッセージ\n            ", 2)
              ], 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "section text-center",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmLogin && _ctx.confirmLogin(...args)))
              }, [
                (_ctx.unreadMessageAndInformationCount !== 0)
                  ? (_openBlock(), _createBlock(_component_AppBadge, {
                      key: 0,
                      variant: "red",
                      class: "notification"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.unreadMessageAndInformationCount), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_MessageSquareIcon, {
                  checked: isExactActive,
                  "wrapper-class": _ctx.textColor(isExactActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isExactActive)])
                }, "\n              メッセージ\n            ", 2)
              ]))
        ]),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        custom: "",
        to: { name: 'FavList' }
      }, {
        default: _withCtx(({ href, navigate }) => [
          _createElementVNode("span", {
            class: "section text-center",
            href: href,
            onClick: ($event: any) => (_ctx.isLoggedIn ? navigate($event) : _ctx.confirmLogin())
          }, [
            _createVNode(_component_FavoriteAndWatchLaterIcon, {
              checked: _ctx.isActiveFavoriteLink,
              "wrapper-class": _ctx.textColor(_ctx.isActiveFavoriteLink)
            }, null, 8, ["checked", "wrapper-class"]),
            _createTextVNode(),
            _createElementVNode("p", {
              class: _normalizeClass(["icon-text", _ctx.textColor(_ctx.isActiveFavoriteLink)])
            }, "\n            お気に入り\n          ", 2)
          ], 8, _hoisted_6)
        ]),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        custom: "",
        to: { name: 'Mypage' }
      }, {
        default: _withCtx(({ href, navigate, isExactActive }) => [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "section text-center",
                href: href,
                onClick: navigate
              }, [
                (_ctx.rejectedNum !== 0)
                  ? (_openBlock(), _createBlock(_component_AppBadge, {
                      key: 0,
                      variant: "red",
                      class: "rejected-num"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.rejectedNum), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_UserIcon, {
                  checked: isExactActive,
                  "wrapper-class": _ctx.textColor(isExactActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isExactActive)])
                }, "\n              マイページ\n            ", 2)
              ], 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "section text-center",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmLogin && _ctx.confirmLogin(...args)))
              }, [
                (_ctx.rejectedNum !== 0)
                  ? (_openBlock(), _createBlock(_component_AppBadge, {
                      key: 0,
                      variant: "red",
                      class: "rejected-num"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.rejectedNum), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_UserIcon, {
                  checked: isExactActive,
                  "wrapper-class": _ctx.textColor(isExactActive)
                }, null, 8, ["checked", "wrapper-class"]),
                _createTextVNode(),
                _createElementVNode("p", {
                  class: _normalizeClass(["icon-text", _ctx.textColor(isExactActive)])
                }, "\n              マイページ\n            ", 2)
              ]))
        ]),
        _: 1
      })
    ])
  ]))
}